<div class="header">
    <div class="logo">
        <a [routerLink]="homeRoute" class="display-flex-horizontal">
            <img
                [src]="brandingHorizontalLogoUrl"
                class="organization-branding-logo organization-branding-logo--horizontal"
                alt="ComplyB4 organization logo"
                (error)="handleBrandingImageError('header_horizontal')"
            >
            <img
                class="logo-fold organization-branding-logo organization-branding-logo--icon"
                [src]="brandingIconLogoUrl"
                alt="ComplyB4 organization icon"
                (error)="handleBrandingImageError('header_icon')"
            >
        </a>
    </div>
    <!--
    <div class="logo logo-dark">
        <a href="">
            <img src="../../../../assets/images/logo/logo_icon.png" alt="Logo">
            <img class="logo-fold" src="assets/images/logo/logo-fold-white.png" alt="Logo">
        </a>
    </div>
    <div class="logo logo-white">
        <a href="">
            <img src="assets/images/logo/logo-white.png" alt="Logo">
            <img class="logo-fold" src="assets/images/logo/logo-fold-white.png" alt="Logo">
        </a>
    </div>
    -->
    <div class="nav-wrap">
        <ul class="nav-left">
            <li class="desktop-toggle">
                <a (click)="toggleFold()">
                    <i nz-icon [nzType]="isFolded? 'menu-unfold':'menu-fold'" class="opacity-07 font-size-25" theme="outline"></i>
                </a>
            </li>
            <li class="mobile-toggle">
                <a (click)="toggleExpand()">
                    <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" class="opacity-07 font-size-25" theme="outline"></i>
                </a>
            </li>
        </ul>
        <ul class="nav-right">
            <li *ngIf="isAdmin && !isFileUploaderUser" class="header-credits-nav-item">
                <button
                    nz-button
                    class="cb4-button header-credits-button"
                    nzType="default"
                    nz-tooltip
                    nzTooltipTitle="Open Organization Settings"
                    aria-label="Open organization settings"
                    (click)="openOrganizationSettings()"
                >
                    <i nz-icon nzType="tags" nzTheme="outline" class="opacity-07"></i>
                    <span class="header-credits-button__label">{{ accountLicenseCredits }}</span>
                    <span class="header-credits-button__text">Assessment Credits Available</span>
                </button>
            </li>
            <li *ngIf="!isFileUploaderUser">
                <button
                    nz-button
                    class="cb4-button header-feedback-button"
                    nzType="default"
                    nz-tooltip
                    nzTooltipTitle="Open App Tutorial"
                    nzTooltipPlacement="bottom"
                    aria-label="Open tutorial"
                    (click)="openTutorialModal()"
                >
                    <i nz-icon nzType="info-circle" class="opacity-07 font-size-20" nzTheme="outline"></i>
                </button>
            </li>
            <li>
                <button
                    nz-button
                    class="cb4-button header-feedback-button"
                    nzType="default"
                    nz-tooltip
                    nzTooltipTitle="Provide Feedback"
                    aria-label="Provide Feedback"
                    (click)="openFeedbackModal()"
                >
                    <i nz-icon nzType="message" class="opacity-07 font-size-20" nzTheme="outline"></i>
                </button>
            </li>
            <li *ngIf="canOpenTasks">
                <button
                    nz-button
                    class="cb4-button header-feedback-button header-tasks-button"
                    nzType="default"
                    nz-tooltip
                    [nzTooltipTitle]="workCountError ? 'My Tasks (count unavailable)' : 'My Tasks'"
                    nzTooltipPlacement="bottom"
                    [attr.aria-label]="taskButtonLabel"
                    [attr.aria-busy]="isLoadingWorkCount"
                    (click)="openMyTasks()"
                >
                    <nz-badge [nzCount]="unfinishedWorkCount || 0" [nzShowZero]="false" [nzOverflowCount]="99">
                        <i nz-icon nzType="check-square" class="opacity-07 font-size-20" nzTheme="outline" aria-hidden="true"></i>
                    </nz-badge>
                </button>
            </li>
            <li>
                <button
                    nz-button
                    class="cb4-button header-feedback-button header-notifications-button"
                    nzType="default"
                    nz-dropdown
                    [nzDropdownMenu]="notificationsMenu"
                    nzTrigger="click"
                    nzPlacement="bottomRight"
                    [nzVisible]="isNotificationsOverlayVisible"
                    nz-tooltip
                    nzTooltipTitle="Notifications"
                    aria-label="Notifications"
                    (nzVisibleChange)="onNotificationsVisibleChange($event)"
                >
                    <nz-badge [nzCount]="unreadNotificationCount" [nzShowZero]="false" [nzOverflowCount]="99">
                        <i nz-icon nzType="bell" class="opacity-07 font-size-20" nzTheme="outline"></i>
                    </nz-badge>
                </button>
                <nz-dropdown-menu #notificationsMenu="nzDropdownMenu">
                    <section class="header-notifications" aria-label="Recent Notifications">
                        <div class="header-notifications__header">
                            <h3>Recent Notifications</h3>
                        </div>
                        <div
                            class="header-notifications__body header-notifications__body--loading"
                            *ngIf="isLoadingNotifications && userNotifications.length === 0"
                        >
                            <app-loading-indicator [message]="''"></app-loading-indicator>
                        </div>
                        <div
                            class="header-notifications__body"
                            *ngIf="userNotifications.length > 0; else notificationEmptyTpl"
                            role="list"
                        >
                            <article
                                *ngFor="let notification of userNotifications"
                                class="header-notifications__item"
                                [class.header-notifications__item--unread]="notification.status === 'unread'"
                                role="listitem"
                            >
                                <div class="header-notifications__content">
                                    <p class="header-notifications__title">{{ notification.title }}</p>
                                    <p class="header-notifications__message">
                                        {{ notification.message }}
                                    </p>
                                    <button
                                        *ngIf="evidenceReminderTarget(notification.link)"
                                        nz-button
                                        nzType="link"
                                        type="button"
                                        class="cb4-button header-notifications__message-link"
                                        (click)="openEvidenceReminder(notification)"
                                    >View evidence</button>
                                    <button
                                        *ngIf="notification.link && notificationLink(notification) as link"
                                        nz-button
                                        nzType="link"
                                        type="button"
                                        class="cb4-button header-notifications__message-link"
                                        [routerLink]="link"
                                        (click)="onNotificationLinkClick(notification, link)"
                                    >{{ notification.link.linkText }}</button>
                                    <time class="header-notifications__time" *ngIf="notification.createdAt">
                                        {{ notification.createdAt | date: 'd MMM y, h:mm a' }}
                                    </time>
                                </div>
                                <button
                                    nz-button
                                    nzType="default"
                                    nzShape="circle"
                                    nzSize="small"
                                    [nzDanger]="true"
                                    type="button"
                                    nz-tooltip
                                    nzTooltipTitle="Delete"
                                    class="cb4-button header-notifications__archive"
                                    [disabled]="archivingNotificationIds.has(notification.id)"
                                    [attr.aria-label]="'Delete ' + notification.title"
                                    (click)="archiveNotification(notification); $event.stopPropagation()"
                                >
                                    <i nz-icon [nzType]="archivingNotificationIds.has(notification.id) ? 'loading' : 'delete'"></i>
                                </button>
                            </article>
                        </div>
                        <ng-template #notificationEmptyTpl>
                            <div class="header-notifications__body" *ngIf="!isLoadingNotifications">
                                <app-table-empty-state message="You have no recent notifications."></app-table-empty-state>
                            </div>
                        </ng-template>
                    </section>
                </nz-dropdown-menu>
            </li>
            <!--
            <li>
                <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="popNotification" [nzPlacement]="'bottomRight'">
                    <nz-badge>
                        <i nz-icon nzType="bell" class="opacity-07 font-size-25" theme="outline"></i>
                    </nz-badge>
                </a>
                <nz-dropdown-menu #popNotification="nzDropdownMenu">
                    <div nz-menu class="pop-notification">
                        <div class="p-v-15 p-h-25 border-bottom d-flex justify-content-between align-items-center">
                            <p class="text-dark font-weight-semibold m-b-0">
                                <i nz-icon nzType="bell" theme="outline"></i>
                                <span class="m-l-10">Notifications</span>
                            </p>
                            <a nz-button class="cb4-button p-v-5" nzType="link" nzSize="small" [routerLink]="''">
                                <small>View All</small>
                            </a>
                        </div>
                        <div class="overflow-y-auto" style="max-height: 300px">
                            <nz-list class="ant-list-item-links" [nzDataSource]="notificationList" [nzRenderItem]="item" [nzItemLayout]="'horizontal'">
                                <ng-template #item let-item>
                                    <nz-list-item>
                                        <a [routerLink]="''">
                                            <div class="d-flex">
                                                <nz-avatar [nzIcon]="item.icon" [ngClass]="item.color"></nz-avatar>
                                                <div class="m-l-15">
                                                    <p class="m-b-0 text-dark">{{item.title}}</p>
                                                    <p class="m-b-0"><small>{{item.time}} ago</small></p>
                                                </div>
                                            </div>
                                        </a>
                                    </nz-list-item>
                                </ng-template>
                            </nz-list>
                        </div>
                    </div>
                </nz-dropdown-menu>
            </li>
            -->
            <li>
                <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'" [nzPlacement]="'bottomRight'">
                    <i nz-icon nzSize="large" nzType="setting" class="opacity-07 font-size-25" nzTheme="outline"></i>
                </span>
                <nz-dropdown-menu #profile="nzDropdownMenu">
                    <ul nz-menu class="p-b-15 p-t-20">
                        <li class="p-h-20 p-b-15 m-b-10 border-bottom">
                            <div class="d-flex m-r-50 align-items-center">
                                <i nz-icon class="opacity-07 font-size-35" nzType="user" nzTheme="outline"></i>
                                <div class="m-l-10">
                                    <p class="m-b-0 text-dark font-weight-semibold">{{userDetails.user_name}}</p>
                                    <p class="m-b-0 opacity-07">{{userDetails.email}}</p>
                                    <p class="m-b-0 opacity-07">{{userDetails.company_name}}</p>
                                </div>
                            </div>
                        </li>
                        <!--
                        <li nz-menu-item *ngIf="canSwitchAccounts">
                            <a class="p-v-5 d-flex align-items-center justify-content-between" [routerLink]="'/switch-account'">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="swap" theme="outline"></i>
                                    <span class="m-l-10">Switch Account</span>
                                </div>
                            </a>
                        </li>
                        -->
                        <li nz-menu-item *ngIf="canSwitchAccounts && !isFileUploaderUser">
                            <a class="p-v-5 d-flex align-items-center justify-content-between" [routerLink]="'/admin-console'">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="dashboard" theme="outline"></i>
                                    <span class="m-l-10">Admin Console</span>
                                </div>
                            </a>
                        </li>
                        <li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between" [routerLink]="userSettingsRoute">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="user" theme="outline"></i>
                                    <span class="m-l-10">User Settings</span>
                                </div>
                            </a>
                        </li>
                        <li nz-menu-item *ngIf="canAccessMerchants && !isFileUploaderUser">
                            <a class="p-v-5 d-flex align-items-center justify-content-between" [routerLink]="'/merchants/list_merchants'">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="shop" theme="outline"></i>
                                    <span class="m-l-10">Merchants/SPs</span>
                                </div>
                            </a>
                        </li>
                        <li nz-menu-item *ngIf="isAdmin && !isFileUploaderUser">
                            <a class="p-v-5 d-flex align-items-center justify-content-between" [routerLink]="['/organization-settings']">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="apartment" theme="outline"></i>
                                    <span class="m-l-10">Organization Settings</span>
                                </div>
                            </a>
                        </li>
                        <li nz-menu-item *ngIf="!isFileUploaderUser">
                            <a
                                class="p-v-5 d-flex align-items-center justify-content-between"
                                [routerLink]="['/release-notes']"
                            >
                                <div>
                                    <i class="opacity-06 font-size-16" nz-icon nzType="file-text" theme="outline"></i>
                                    <span class="m-l-10">Release Notes</span>
                                </div>
                            </a>
                        </li>
                        <li nz-menu-item>
                            <a
                                class="p-v-5 d-flex align-items-center justify-content-between"
                                [routerLink]="['/support']"
                            >
                                <div>
                                    <i class="opacity-06 font-size-16" nz-icon nzType="customer-service" theme="outline"></i>
                                    <span class="m-l-10">Support</span>
                                </div>
                            </a>
                        </li>
                        <li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between" (click)="logout()">
                                <div>
                                    <i class="opacity-06 font-size-16" nz-icon nzType="logout" theme="outline"></i>
                                    <span class="m-l-10">Logout</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </li>
        </ul>
    </div>
</div>

<nz-modal
    [(nzVisible)]="isFeedbackModalVisible"
    nzTitle="Provide Feedback"
    [nzFooter]="null"
    [nzMaskClosable]="false"
    [nzClosable]="!isSubmittingFeedback"
    nzCentered
    (nzOnCancel)="handleFeedbackCancel()"
>
    <ng-container *nzModalContent>
        <p class="m-b-15">
            Let us know about any ideas, questions, or issues you encounter while using the app. We'll route your
            feedback to our support team and respond within 24 hours.
        </p>

        <form nz-form nzLayout="vertical" [formGroup]="feedbackForm" (ngSubmit)="submitFeedback()">
            <nz-alert
                *ngIf="feedbackSubmitSuccess"
                nzType="success"
                nzShowIcon
                nzMessage="Thanks for your feedback!"
                nzDescription="We've logged your note and emailed you a confirmation."
                class="m-b-15"
            ></nz-alert>

            <nz-alert
                *ngIf="feedbackSubmitError"
                nzType="error"
                nzShowIcon
                [nzMessage]="feedbackSubmitError"
                class="m-b-15"
            ></nz-alert>

            <nz-form-item>
                <nz-form-label nzFor="feedbackMessage" nzRequired>Feedback</nz-form-label>
                <nz-form-control [nzErrorTip]="feedbackErrorTpl">
                    <textarea
                        nz-input
                        id="feedbackMessage"
                        formControlName="feedback"
                        rows="6"
                        maxlength="5000"
                        [nzAutosize]="{ minRows: 4, maxRows: 10 }"
                        placeholder="Share any thoughts, issues, or requests."
                    ></textarea>
                    <ng-template #feedbackErrorTpl>
                        <ng-container *ngIf="feedbackControl?.hasError('required')">
                            Please share your feedback so we can help.
                        </ng-container>
                        <ng-container *ngIf="feedbackControl?.hasError('maxlength')">
                            Feedback must be 5,000 characters or fewer.
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <div class="d-flex justify-content-end">
                <button
                    type="button"
                    nz-button
                    class="cb4-button"
                    nzType="default"
                    [disabled]="isSubmittingFeedback"
                    (click)="handleFeedbackCancel()"
                >
                    Cancel
                </button>
                <button
                    nz-button
                    class="cb4-button m-l-10"
                    nzType="primary"
                    nzSize="large"
                    type="submit"
                    [disabled]="isSubmittingFeedback"
                    [nzLoading]="isSubmittingFeedback"
                >
                    Submit Feedback
                </button>
            </div>
        </form>
    </ng-container>
</nz-modal>

<nz-modal
    [(nzVisible)]="isTutorialModalVisible"
    nzTitle="Getting Started"
    [nzFooter]="null"
    [nzMaskClosable]="false"
    nzCentered
    [nzWidth]="1000"
    (nzOnCancel)="closeTutorialModal()"
>
    <ng-container *nzModalContent>
        <div class="tutorial-modal">
            <div class="tutorial-modal__header">
                <div class="tutorial-modal__branding">
                    <img
                        src="assets/images/logo/logo_icon_and_text_horizontal.png"
                        alt="ComplyB4"
                        class="tutorial-modal__logo"
                    >
                    <div>
                        <p class="tutorial-modal__subtitle">Empowering Your Compliance Journey</p>
                    </div>
                </div>
                <nz-steps [nzCurrent]="tutorialStepIndex" nzSize="small" class="tutorial-modal__steps">
                    <nz-step *ngFor="let step of tutorialSlides"></nz-step>
                </nz-steps>
            </div>

            <div class="tutorial-modal__body" [ngSwitch]="currentTutorialSlide">
                <section *ngSwitchCase="'welcome'" class="tutorial-slide">
                    <div class="tutorial-slide__content">
                        <h4 class="text-center">Welcome to the ComplyB4 app</h4>
                        <p>
                            We are excited to have you here. This quick guide will help you get started and highlight the essentials available to you right away.
                        </p>
                        <p class="tutorial-slide__note">
                            You can reopen this guide anytime using the <i nz-icon nzType="info-circle" class="tutorial-inline-icon" nzTheme="outline"></i> icon in the header bar at the top right of your screen.
                        </p>
                        <div class="tutorial-slide__links">
                            <a
                                nz-button
                                class="cb4-button"
                                nzType="primary"
                                [routerLink]="homeRoute"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="dashboard" nzTheme="outline"></i>
                                {{ isFileUploaderUser ? 'Go to Secure Storage' : 'Go to Dashboard' }}
                            </a>
                        </div>
                    </div>
                    <div class="tutorial-slide__media">
                        <img
                            src="assets/images/tutorial/dashboard_screenshot.png"
                            alt="Dashboard preview"
                        >
                    </div>
                </section>

                <section *ngSwitchCase="'assessments'" class="tutorial-slide">
                    <div class="tutorial-slide__content">
                        <h4>Assessments, Merchants, and Assignments</h4>
                        <ul class="tutorial-slide__list">
                            <li>
                                <strong>Assessments</strong> are the compliance forms you complete (like the <i>PCI DSS Report on Compliance</i> or a <i>PCI DSS Self-Assessment Questionnaire</i>).
                            </li>
                            <li>
                                Each Assessment is assigned to a <strong>Merchant / Service Provider</strong>, which is the target of the assessment.
                            </li>
                            <li>
                                <strong>Assignees</strong> are the users who can update, complete, and/or read a specific assessment.
                            </li>
                        </ul>
                        <p *ngIf="isAdmin">
                            As an administrator, you have the ability to start, complete, and assign users to assessments.
                        </p>
                        <div class="tutorial-slide__links">
                            <a
                                *ngIf="isAdmin"
                                nz-button
                                class="cb4-button"
                                nzType="primary"
                                [routerLink]="['/add-assessment']"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
                                Start an Assessment
                            </a>
                            <a
                                *ngIf="canAccessMerchants"
                                nz-button
                                class="cb4-button"
                                nzType="default"
                                [routerLink]="['/merchants/list_merchants']"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="shop" nzTheme="outline"></i>
                                View Merchants/SPs
                            </a>
                        </div>
                    </div>
                    <div class="tutorial-slide__media">
                        <img
                            src="assets/images/tutorial/new_assessment.png"
                            alt="Assessment form preview"
                        >
                    </div>
                </section>

                <section *ngSwitchCase="'dashboard'" class="tutorial-slide">
                    <div class="tutorial-slide__content">
                        <h4>Understand the dashboard at a glance</h4>
                        <p *ngIf="isAdmin; else nonAdminDashboardCopy">
                            On the main dashboard, you can see all assessments that have been started in your
                            organization, followed by the Merchants/SPs each assessment targets and the status of
                            other users in your organization.
                        </p>
                        <ng-template #nonAdminDashboardCopy>
                            <p>
                                On the main dashboard, you can see assessments you've been assigned to. If you haven't
                                been assigned to any assessments yet, reach out to an administrator at your
                                organization; they can start assessments and assign them.
                            </p>
                        </ng-template>
                        <p>
                            You can use the side menu on the left to quickly navigate between the dashboard, assessments, and merchants/entities.
                        </p>
                        <p>
                            Settings can be accessed via the <i nz-icon nzType="setting" class="tutorial-inline-icon" nzTheme="outline"></i> settings icon on the top right of the screen.
                        </p>
                        <div class="tutorial-slide__links">
                            <a
                                nz-button
                                class="cb4-button"
                                nzType="primary"
                                [routerLink]="homeRoute"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="dashboard" nzTheme="outline"></i>
                                {{ isFileUploaderUser ? 'Go to Secure Storage' : 'Go to Dashboard' }}
                            </a>
                            <a
                                nz-button
                                class="cb4-button"
                                nzType="default"
                                [routerLink]="userSettingsRoute"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="user" nzTheme="outline"></i>
                                User Settings
                            </a>
                        </div>
                    </div>
                </section>

                <section *ngSwitchCase="'global-admin'" class="tutorial-slide">
                    <div class="tutorial-slide__content">
                        <h4>Invite and manage your team</h4>
                        <p>
                            As the global administrator for your organization, you have the ability to invite other users to join your organization in the ComplyB4 app.
                        </p>
                        <p>
                            Users you grant the <strong>Admin</strong> role to will have the ability to start, complete, and assign users to assessments
                        </p>
                        <p>
                            Other users you invite must be assigned to assessments before they can see or update them.
                        </p>
                        <div class="tutorial-slide__links">
                            <a
                                nz-button
                                class="cb4-button"
                                nzType="primary"
                                [routerLink]="['/organization-settings']"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="team" nzTheme="outline"></i>
                                Organization Settings
                            </a>
                            <a
                                nz-button
                                class="cb4-button"
                                nzType="default"
                                [routerLink]="userSettingsRoute"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="user-switch" nzTheme="outline"></i>
                                Manage Users
                            </a>
                        </div>
                    </div>
                </section>

                <section *ngSwitchCase="'features'" class="tutorial-slide">
                    <div class="tutorial-slide__content">
                        <h4>Assessments adapt as you work</h4>
                        <p>
                            The assessments are pre-populated with merchant details and assigned assessor information. As you respond, the forms update dynamically based on your entries, and the app helps you track progress toward completion. Additional tools include:
                        </p>
                        <ul class="tutorial-slide__list">
                            <li>
                                Upload images, diagrams, and add links to supporting evidence
                            </li>
                            <li>
                                Digitally sign assessments
                            </li>
                            <li>
                                Generate and print completed assessments and their attestations of compliance
                            </li>
                        </ul>
                        <div class="tutorial-slide__links">
                            <a
                                nz-button
                                class="cb4-button"
                                nzType="primary"
                                [routerLink]="homeRoute"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="file-done" nzTheme="outline"></i>
                                {{ isFileUploaderUser ? 'Go to Secure Storage' : 'Review Assessments' }}
                            </a>
                            <a
                                *ngIf="isAdmin"
                                nz-button
                                class="cb4-button"
                                nzType="default"
                                [routerLink]="['/add-assessment']"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
                                Start an Assessment
                            </a>
                        </div>
                    </div>
                    <div class="tutorial-slide__media">
                        <img
                            src="assets/images/tutorial/pdf_preview.png"
                            alt="Assessment form preview"
                        >
                    </div>
                </section>

                <section *ngSwitchCase="'support'" class="tutorial-slide">
                    <div class="tutorial-slide__content">
                        <h4>Feedback and support are always close</h4>
                        <p>
                            You can provide feedback anytime by clicking the <i nz-icon nzType="message" class="tutorial-inline-icon" nzTheme="outline"></i> icon in the header navigation bar, the Support link in the header submenu list, or by reaching out to ComplyB4 directly.
                        </p>
                        <p>
                            <a href="mailto:info@complyb4.com" (click)="closeTutorialModal()">info&#64;complyb4.com</a> | <a href="tel:+353879403543" (click)="closeTutorialModal()">+353 87 940 3543</a>
                        </p>
                        <p class="tutorial-slide__note">
                            You can reopen this tutorial anytime using the <i nz-icon nzType="info-circle" class="tutorial-inline-icon" nzTheme="outline"></i> icon in the header navigation menu.
                        </p>
                        <div class="tutorial-slide__links">
                            <a
                                nz-button
                                class="cb4-button"
                                nzType="primary"
                                [routerLink]="['/support']"
                                (click)="closeTutorialModal()"
                            >
                                <i nz-icon nzType="customer-service" nzTheme="outline"></i>
                                Contact Support
                            </a>
                            <a
                                nz-button
                                class="cb4-button"
                                nzType="default"
                                (click)="openFeedbackModal(); closeTutorialModal()"
                            >
                                <i nz-icon nzType="message" nzTheme="outline"></i>
                                Provide Feedback
                            </a>
                        </div>
                    </div>
                </section>
            </div>

            <div class="tutorial-modal__footer">
                <div class="tutorial-modal__footer-actions">
                    <button nz-button class="cb4-button" nzType="default" (click)="closeTutorialModal()">
                        <i nz-icon nzType="close" nzTheme="outline"></i>
                        Skip Intro
                    </button>
                    <button
                        nz-button
                        class="cb4-button"
                        nzType="default"
                        (click)="tutorialStepIndex = tutorialStepIndex - 1"
                        [disabled]="tutorialStepIndex === 0"
                    >
                        <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
                        Previous
                    </button>
                    <p class="tutorial-modal__step">Slide {{ tutorialStepLabel }}</p>
                    <button nz-button class="cb4-button" nzType="primary" (click)="advanceTutorial()">
                        <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
                        {{ isLastTutorialStep ? 'Finish' : 'Next' }}
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</nz-modal>
